import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';
import { MeasureDataResult } from '../scanDataApi/hooks/useColumnsExistInDB';
import { DuckQueryReturnOneType } from './hooks/useDuckQueryScanData';

export enum DuckDBStatusEnum {
  initial = 'initial',
  updating = 'updating',
  dataLoaded = 'dataLoaded',
  error = 'error',
}

export const queryMap = [
  { name: 'Select All', query: 'SELECT * FROM scanData;' },
  {
    name: 'Average Raw Count',
    query: 'SELECT AVG(raw_count) as raw_count from scanData;',
  },
  {
    name: 'Distinct Class Names',
    query: 'SELECT DISTINCT class_name FROM scanData;',
  },
  { name: 'Summarize', query: 'summarize scanData;' },
  {
    name: 'Total Point Count',
    query: 'select count(distinct(point_id)) from scanData;',
  },
];

interface DuckDBState {
  duckDBStatus: DuckDBStatusEnum;
  debugPopupQueryText: string;
  selectedQueryName: string;
  scanDataTableExists: boolean;
  columnsExistInDbData: DuckQueryReturnOneType<MeasureDataResult> | null;
}

const initialState: DuckDBState = {
  duckDBStatus: DuckDBStatusEnum.initial,
  debugPopupQueryText: '',
  selectedQueryName: '',
  scanDataTableExists: false,
  columnsExistInDbData: null,
};

export const duckDBState = createSlice({
  name: 'duckDB',
  initialState,
  reducers: {
    initDuckDBState: () => initialState,
    setDuckDBStatus: (state, action: PayloadAction<DuckDBStatusEnum>) => {
      state.duckDBStatus = action.payload;
    },
    setDebugPopupQueryText: (state, action: PayloadAction<string>) => {
      state.debugPopupQueryText = action.payload;
    },
    setSelectedQueryName: (state, action: PayloadAction<string>) => {
      state.selectedQueryName = action.payload;
    },
    setScanDataTableExists: (state, action: PayloadAction<boolean>) => {
      state.scanDataTableExists = action.payload;
    },
    setColumnsExistInDbData: (
      state,
      action: PayloadAction<DuckQueryReturnOneType<MeasureDataResult> | null>
    ) => {
      state.columnsExistInDbData = action.payload;
    },
  },
});

export const {
  initDuckDBState,
  setDuckDBStatus,
  setDebugPopupQueryText,
  setSelectedQueryName,
  setScanDataTableExists,
  setColumnsExistInDbData,
} = duckDBState.actions;

export const selectDuckDBStatus = (state: RootState) =>
  state.duckDB.duckDBStatus;
export const selectDebugPopupQueryText = (state: RootState) =>
  state.duckDB.debugPopupQueryText;
export const selectSelectedQueryName = (state: RootState) =>
  state.duckDB.selectedQueryName;
export const selectScanDataTableExists = (state: RootState) =>
  state.duckDB.scanDataTableExists;
export const selectColumnsExistInDbData = (state: RootState) =>
  state.duckDB.columnsExistInDbData;
export const selectAllDuckDBState = (state: RootState) => state.duckDB;

export default duckDBState.reducer;
